import { Link } from "react-router-dom/cjs/react-router-dom.min";
import Contact from "../Pages/Contact";
import "../css/Nav.css"
import { useState, useRef } from "react";

function Nav({headline, homeRef, filmMakingRef, contactRef, intimacyRef, sendDataToApp}){

    const [data, setData] = useState("");
    
    const handleClick = (e) => {
        if(e == "Intimacy"){
            intimacyRef.current?.scrollIntoView({behavior: 'smooth'});
            sendDataToApp("Intimacy Coordination")
        }
        if(e == "Contact"){
            contactRef.current?.scrollIntoView({behavior: 'smooth'});
            sendDataToApp("Contact")
        }
        if(e == "Home"){
            homeRef.current?.scrollIntoView({behavior: 'smooth'});
            sendDataToApp("About Gaby");
        }
        if(e == "Writing/Directing"){
            filmMakingRef.current?.scrollIntoView({behavior: 'smooth'});
            sendDataToApp("Writing/Directing");
        }
        console.log("clicked");
    }

    //sendDataToApp(data);


   

    return (
        <>
            <nav>
                <div className="links">
                    <a onClick={() => handleClick("Home")} id="GabyEstabrooks">
                        <h1 className="NavHeader" >Gaby Estabrooks</h1>
                    </a>
                    <div className="navFlex">
                        <a className="link" onClick={() =>handleClick("Writing/Directing")} id="link2">Intimacy Direction & Coordination</a>
                        <a href="/page3" className="link" id="link3">Art</a>
                        <a href="/page4" className="link" id="link4">Comedy</a>
                        <a className="link" onClick={() => handleClick("Intimacy")} id="link5">Writing/Directing</a>
            
                        <a className="button" onClick={() => handleClick("Contact")}>Let's Talk</a>
                    </div>
                </div>
                <div className="navLine">
                    <div className="LineL"></div>
                    <p className="Header">{headline}</p>
                    <div className="LineR"></div>
                </div>

            </nav>

        </>
    );
}

export default Nav;